import { SortDirection } from '@/enums/sort';
import type { Sort } from '@/types/sort.type';

export const buildNextSort = (column: string, direction?: SortDirection): Sort => {
    const sortKey = direction && direction !== SortDirection.NONE ? column : undefined;
    const sortOrder = direction !== SortDirection.NONE ? direction : undefined;

    return { sortKey, sortOrder };
};
